import { render, staticRenderFns } from "./Hot.vue?vue&type=template&id=8e032a1e&scoped=true"
import script from "./Hot.vue?vue&type=script&lang=js"
export * from "./Hot.vue?vue&type=script&lang=js"
import style0 from "./Hot.vue?vue&type=style&index=0&id=8e032a1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e032a1e",
  null
  
)

export default component.exports
import {QSpinnerDots} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSpinnerDots})
